import { render, staticRenderFns } from "./saas-nsr-footer.vue?vue&type=template&id=64aa8db0&scoped=true"
import script from "./saas-nsr-footer.vue?vue&type=script&lang=js"
export * from "./saas-nsr-footer.vue?vue&type=script&lang=js"
import style0 from "./saas-nsr-footer.vue?vue&type=style&index=0&id=64aa8db0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aa8db0",
  null
  
)

export default component.exports